export default __webpack_public_path__ + "d3c2ae8b20f90ec3ccd57291fd99613d.svg";